 <div class="d-flex flex-column margin-bottom-custom">
  <div class="alert-div" *ngIf="emailIsEdited">
    <div
      class="min_media alert alert-success d-flex align-items-start alert-dismissible fade show mb-5 mt-4 successMessage">
      <img src="./assets/svg/successIcon.svg" alt="Success Icon" class="me-2">
      <div>Check your inbox to verify new email and log in.</div>
    </div>
  </div>
  <div class="auth-form-light text-left form-style w-100">
    <div class="card-header d-flex justify-content-between py-6 custom-border-bottom with-shadow">
      <h4 class="card-title mb-0 profile-title" #cardTitle>{{ editReady ? 'Edit Profile' : 'My Profile' }}</h4>
      <div class="d-flex justify-content-end">
        <img (click)="onAllowUpdate()" *ngIf="!editReady" class="update-icon profilePic" #updateIcon
             src="assets/svg/editIcon.svg" alt="">
      </div>
    </div>
    <div class="d-flex mt-5 profilePic pb-3 px-sm-7">
      <label for="forImage">
        <div id="forImage" class="col-sm-12 text-center image">
          <img [src]="tempProfileImageUrl || currentProfileImage || 'assets/svg/defaultUserIcon.svg'" alt=""
               class="image-style">
        </div>
      </label>
      <div class="d-flex justify-content-end">
        <button type="button" (click)="openImageInput()" class="photo-icon" *ngIf="editReady">
          <i class="material-icons" *ngIf="showCameraIcon">photo_camera</i>
          <i class="material-icons" *ngIf="!showCameraIcon">clear</i>
        </button>
      </div>
      <div class="d-flex justify-content-end ms-3">
        <button type="button" (click)="deleteProfileImage()" class="clear-icon" *ngIf="editReady && !isDefaultImage()">
          <i class="material-icons">clear</i>
        </button>
      </div>
    </div>
    <input type="file" #imageInput name="profilePic" hidden [disabled]="!editReady" (change)="onProfileImageChange($event)"
           accept="image/jpeg,image/png">
    <form [formGroup]="form" method="post"  class="pt-3 pb-7 px-sm-7">
      <div class="form-group mb-3 d-flex">
        <div *ngIf="editReady" class="mr-2 flex-fill me-4">
          <label class="form-label">Name</label>
          <input formControlName="name" type="text" id="name"
                 class="form-control nn"/>
        </div>
        <div *ngIf="editReady" class="ml-2 flex-fill">
          <label class="form-label">Surname</label>
          <input formControlName="surname" type="text" id="surname"
                 class="form-control nn"/>
        </div>
      </div>
      <div class="form-group mb-3 d-flex">
        <div *ngIf="editReady" class="mr-2 flex-fill me-4">
          <label class="form-label">Email</label>
          <input formControlName="email" type="email" id="email"
                 placeholder="Email*"
                 class="form-control"
                 (keydown.enter)="this.getUserCardUtil().onEnter($event)"
                 [ngClass]="{'has-error': (profileEditControl['email'].invalid && profileEditControl['email'].touched) || emailExists}"
                 (input)="resetErrorMessage()" [readonly]="!editReady"/>
          <div *ngIf="profileEditControl['email'].invalid && profileEditControl['email'].touched"
               class="validation">
            <small *ngIf="profileEditControl['email'].errors?.['required']">Enter email address</small>
            <small *ngIf="profileEditControl['email'].errors?.['pattern']">Enter valid email address</small>
          </div>
          <small *ngIf="emailExists" class="validation">Email already exists</small>
        </div>
        <div [ngClass]="{'d-block': editReady, 'd-none': !editReady}" class="mr-2 flex-fill">
            <label class="form-label">Phone</label>
            <input formControlName="phoneNumber" type="tel" id="phone" #phoneInput
                   class="form-control nn" (blur)="validatePhoneNumber()"
                   (keydown.enter)="this.getUserCardUtil().onEnter($event)"
                   [ngClass]="{'has-error': profileEditControl['phoneNumber'].invalid && profileEditControl['phoneNumber'].touched
                        || profileEditControl['phoneNumber'].value !== '' && invalidPhoneNumber}"
                   [readonly]="!editReady"/>
            <div *ngIf="profileEditControl['phoneNumber'].invalid && profileEditControl['phoneNumber'].touched"
                 class="validation">
              <small *ngIf="profileEditControl['phoneNumber'].errors?.['required']">Enter phone number</small>
            </div>
            <div *ngIf="invalidPhoneNumber && profileEditControl['phoneNumber']?.value !== ''"
                 class="validation">
              <small>Enter a valid phone number</small>
            </div>
        </div>
      </div>
      <app-sidebar [user]="user" (cancelProfileEdit)="onCancelProfileEdit()"></app-sidebar>
      <app-navbar class="navbar-div" (cancelProfileEditForNavbar)="onCancelProfileEdit()"></app-navbar>
      <div class="mt-3 d-flex buttons-style">
        <button type="submit" class="btn save-button squer-btn mt-2 mr-2 d-block fixed-width-btn"
                #saveButton *ngIf="editReady">{{ 'user_card.save' | translate }}
        </button>
        <button type="button" #cancelButton (click)="onCancelProfileEdit()" *ngIf="editReady"
                class="btn cancel-button squer-btn mt-2 mr-2 font-weight-medium auth-form-btn ms-4 d-block fixed-width-btn">
          {{ 'user_card.cancel' | translate }}
        </button>
      </div>
      <div *ngIf="!editReady">
        <div class="user-information w-100">
          <span class="fio-user">{{user.name}} {{user.surname}}</span>
        </div>
        <div class="d-flex mb-3 pb-3 username-style-mobile">
        </div>
        <div>
          <div class="d-flex mt-2">
            <mat-icon>perm_identity</mat-icon>
            <p class="ms-2 break-word">{{user.name}} {{user.surname}}</p>
          </div>
          <div class="d-flex">
            <mat-icon>mail_outline</mat-icon>
            <p class="ms-2 break-word">{{user.email}}</p>
          </div>
          <div class="d-flex">
            <mat-icon>phone_android</mat-icon>
            <p class="ms-2 break-word">{{user.phoneNumber}}</p>
          </div>
          <div class="logout-div mt-3">
            <button type="button" routerLink="/home" class="logout-button btn btn-info effect-btn squer-btn "
                    (click)="navigateToLogin()">
              <mat-icon class="logout-icon">exit_to_app</mat-icon>
              <a class="logout-link ms-2">Logout</a>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
 </div>
